import { Group, Input, InputAddon } from "@chakra-ui/react"
import { BiSearch } from "react-icons/bi";
import { useEffect, useState } from "react";

interface SearchBoxProps {
    search: string;
    handleSearchChange: Function
    removeTheRandomMargin?: boolean
}

export const SearchBox = (props: SearchBoxProps) => {
    const [inputValue, setInputValue] = useState(props.search);

    useEffect(() => {
        setInputValue(props.search);
    }, [props.search]);

    useEffect(() => {
        const timeout = setTimeout(() => {
            props.handleSearchChange({
                currentTarget: { value: inputValue },
                target: { value: inputValue },
            });
        }, 200);

        return () => clearTimeout(timeout);
    }, [inputValue]);

    return (
        <Group attached display={{ base: "none", lg: "flex" }} marginLeft={"10px"} verticalAlign={"middle"}>
            <InputAddon justifyContent={"center"} height={"30px"}  marginTop={props.removeTheRandomMargin ? "0" : "8px"} borderColor={"backgroundLightGrey"} background={"backgroundLightGrey"}><BiSearch size={"18px"} /></InputAddon>
            <Input bg={"backgroundDarkGrey"} height={"30px"} placeholder={" Search Bar"} paddingLeft={"10px"} value={inputValue} onChange={(e) => setInputValue(e.currentTarget.value)} width={"200px"} ></Input>
        </Group>
    )
}